import { render, staticRenderFns } from "./ParticipantFlow.vue?vue&type=template&id=2fc73875&scoped=true"
import script from "./ParticipantFlow.vue?vue&type=script&lang=js"
export * from "./ParticipantFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc73875",
  null
  
)

export default component.exports